export default __webpack_public_path__ + "media/vht_logo_white.1c34f8f4.svg";